import React from "react";
import { Button } from "react-bootstrap";
export const S3AudioColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { onClickOfUploadAudioActionButton, syncOrderIds, data }
) => {
  const { meta_data } = row || {};
  let isVisible = false;
  for (let index = 0; index < meta_data.length; index++) {
    const element = meta_data[index];
    const { key, value } = element || {};
    if (key === "_wcuf_uploaded_files") {
      const values = Object.values(value);
      for (let i = 0; i < values.length; i++) {
        const mediaFile = values[i];
        const { ID3_info } = mediaFile;
        const [mediaInfo] = ID3_info || {};
        const { type } = mediaInfo || {};
        if (type === "audio") {
          isVisible = true;
        }
      }
    }
  }

  const renderUploadButton = () => {
    return (
      isVisible && (
        <Button
          variant="btn btn-icon btn-light-danger btn-sm mx-1 font-size-sm text-center"
          onClick={() => {
            onClickOfUploadAudioActionButton(row);
          }}
        >
          <i className="fas fa-upload"></i>
        </Button>
      )
    );
  };
  return <>{renderUploadButton()}</>;
};
